import BaseUseCase from "../../../base_use_case.js";

class DeleteUserUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "delete",
      url: `/api/v1/admin/users/users/${identifier}`,
    });
  }
}

const instance = new DeleteUserUseCase();
export default instance;
